import React from 'react';
import sanitizeHtml from 'sanitize-html';

const sanitizeAndRenderHtml = (
  content: string | undefined
): { __html: string } | undefined => {
  if (!content) return undefined;

  const sanitized = sanitizeHtml(content, {
    allowedAttributes: {
      span: ['class'],
    },
    allowedClasses: {
      span: ['*'], // Allow all classes on span elements
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 'span', 'br', 'p'],
  });

  return { __html: sanitized };
};

const BenefitsHeader = ({
  sectionHeading = 'Benefits',
  selectedBenefitName,
}: {
  selectedBenefitName?: string;
  sectionHeading?: string;
}) => (
  <div className="mb-[45px] text-center">
    <h2
      className="font-['Work_Sans'] text-[16px] leading-[25px] font-medium tracking-[2%] uppercase"
      dangerouslySetInnerHTML={sanitizeAndRenderHtml(sectionHeading)}
    />
    {selectedBenefitName && (
      <h2
        className="mt-6 font-['Work_Sans'] text-[20px] leading-[25px] text-black uppercase transition-all duration-500 ease-in-out sm:hidden"
        dangerouslySetInnerHTML={sanitizeAndRenderHtml(selectedBenefitName)}
      />
    )}
  </div>
);

export default BenefitsHeader;
